import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useStoreSettings } from '../../hooks/useStoreSettings';
import ContactModal from './ContactModal';
import styles from './Footer.module.css';

const Footer = () => {
  const { settings, loading } = useStoreSettings();
  const footerContent = settings?.footer_content;
  const [contactOpen, setContactOpen] = useState(false);

  if (loading) return null;

  const defaultContent = {
    company_info: {
      about: 'About our company text here',
      address: 'Company Address',
      phone: 'Phone Number',
      email: 'company@email.com'
    },
    quick_links: [
      { title: 'Home', url: '/' },
      { title: 'Products', url: '/products' },
      { title: 'About', url: '/about' },
      { title: 'Contact', url: '/contact' }
    ],
    social_links: {
      facebook: '',
      instagram: '',
      twitter: '',
      linkedin: ''
    },
    bottom_text: 'Copyright © 2024. All rights reserved.'
  };

  const content = footerContent || defaultContent;

  const bgColor = (content as any).background_color;

  return (
    <footer
      className={styles.footer}
      style={bgColor ? { backgroundColor: bgColor } : undefined}
    >
      <div className={styles.footerContent}>
        <div className={styles.companyInfo}>
          <h3>O nama</h3>
          <p>{content.company_info.about}</p>
          <div className={styles.contactInfo}>
            {content.company_info.address && (
              <p>{content.company_info.address}</p>
            )}
            {content.company_info.phone && (
              <p>{content.company_info.phone}</p>
            )}
            {content.company_info.email && (
              <p>{content.company_info.email}</p>
            )}
          </div>
          <button
            type="button"
            className={styles.contactButton}
            onClick={() => setContactOpen(true)}
          >
            Kontakt
          </button>
        </div>

        <div className={styles.quickLinks}>
          <h3>Brzi linkovi</h3>
          <ul>
            {content.quick_links.map((link, index) => (
              <li key={index}>
                <Link to={link.url}>{link.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.socialLinks}>
          <h3>Zapratite nas</h3>
          <div className={styles.socialIcons}>
            {content.social_links.facebook && (
              <a href={content.social_links.facebook} target="_blank" rel="noopener noreferrer">
                Facebook
              </a>
            )}
            {content.social_links.instagram && (
              <a href={content.social_links.instagram} target="_blank" rel="noopener noreferrer">
                Instagram
              </a>
            )}
            {content.social_links.twitter && (
              <a href={content.social_links.twitter} target="_blank" rel="noopener noreferrer">
                Twitter
              </a>
            )}
            {content.social_links.linkedin && (
              <a href={content.social_links.linkedin} target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            )}
          </div>
        </div>
      </div>

      <div className={styles.bottomBar}>
        <p>{content.bottom_text}</p>
      </div>

      {contactOpen && <ContactModal onClose={() => setContactOpen(false)} />}
    </footer>
  );
};

export default Footer; 